import { render, staticRenderFns } from "./DetailVerificationKtp.vue?vue&type=template&id=75378caa"
import script from "./DetailVerificationKtp.vue?vue&type=script&lang=js"
export * from "./DetailVerificationKtp.vue?vue&type=script&lang=js"
import style0 from "./DetailVerificationKtp.vue?vue&type=style&index=0&id=75378caa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports